const firebaseConfig = {
    apiKey: "AIzaSyApzmolRiKmrKGM85lQtTAURMyN2UEUTA4",
    authDomain: "shop-bd-bang.firebaseapp.com",
    projectId: "shop-bd-bang",
    storageBucket: "shop-bd-bang.appspot.com",
    messagingSenderId: "38022792726",
    appId: "1:38022792726:web:f4338c419a1538e6cf9737"
  };

  export default firebaseConfig;